import { useEffect, useLayoutEffect, useRef } from 'react';
import _ from 'lodash';

import useSize from '../../utilities/UseSize';
import useStyles from './NetworkGraphStyles';
import drawGraph from './NetworkGraphHelper';

export default function NetworkGraph({ options, data }) {
    const classes = useStyles();
    const containerRef = useRef();
    const svgRef = useRef();
    const resizeCallbackRef = useRef();
    const { width } = useSize(containerRef);

    useEffect(() => {
        if (!svgRef.current) return;
        resizeCallbackRef.current = drawGraph(svgRef.current, data, options);
    }, [svgRef, options, data]);

    useLayoutEffect(() => {
        if (width && _.isFunction(resizeCallbackRef.current)) resizeCallbackRef.current(width);
    }, [width]);

    return (
        <div className={classes.netGraph} ref={containerRef}>
            <svg ref={svgRef} />
        </div>
    );
}
